import { tenants } from "../../config/tenants.js";
import { slugify } from "../../utils/slugify.js";
import type { CourseType } from "../CourseType.js";
import type { Locale } from "../Locale.js";
import { courseTypeNameMap } from "../names/courseTypeNameMap.js";
import { getCoursesListingPath } from "./getCoursesListingPath.js";

export function getCourseTypePath(locale: Locale, courseType: CourseType): string {
	return `${getCoursesListingPath(tenants[locale])}/${slugify(courseTypeNameMap[courseType][locale])}`;
}
